import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export function Footer() {
  const { t } = useLang();
  return (
    <footer id="contact" className="relative border-t border-white/10 bg-[#0C0C0E] mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <p className="text-zinc-500 text-sm max-w-xs leading-relaxed">{t("footer.tagline")}</p>
        </div>

        <div>
          <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#00E5FF] mb-5">{t("footer.contact")}</h4>
          <ul className="space-y-4 text-sm text-zinc-400">
            <li>
              <a href="tel:+32497503915" data-testid="footer-phone" className="flex items-center gap-3 group w-fit">
                <Phone className="w-5 h-5 text-[#E60000]" />
                <span className="font-display font-900 text-white text-xl sm:text-2xl tracking-tight group-hover:text-[#E60000] transition-colors">+32 497 50 39 15</span>
              </a>
            </li>
            <li><a href="mailto:cardream@yahoo.com" className="flex items-center gap-3 hover:text-white transition-colors w-fit"><Mail className="w-4 h-4 text-[#E60000]" /> cardream@yahoo.com</a></li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#E60000] mt-0.5 shrink-0" />
              <a href="https://maps.google.com/?q=Koeweidestraat+47+C,+1785+Merchtem,+Belgique" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-address">
                Koeweidestraat 47 C<br />1785 Merchtem<br />Belgique
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#00E5FF] mb-5">{t("footer.quick")}</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><Link to="/booking" className="hover:text-white transition-colors">{t("footer.book")}</Link></li>
            <li><Link to="/admin" className="hover:text-white transition-colors">{t("footer.admin")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center">
        <p className="font-mono-tech text-[11px] tracking-[0.2em] text-zinc-600 uppercase">
          © {new Date().getFullYear()} Garage Ter Spelt — {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
}
